export default "__VITE_ASSET__jf1ieMSu__"